import { render, staticRenderFns } from "./Reservation.vue?vue&type=template&id=5712f9c8&scoped=true"
import script from "./Reservation.vue?vue&type=script&lang=js"
export * from "./Reservation.vue?vue&type=script&lang=js"
import style0 from "./Reservation.vue?vue&type=style&index=0&id=5712f9c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5712f9c8",
  null
  
)

export default component.exports